import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import PricingPage from "./pages/PricingPage";
import OurClientsPage from "./pages/OurClientsPage";
import AboutPage from "./pages/AboutPage";
import GetStartedPage from "./pages/GetStartedPage";
import ThankYouPage from "./pages/ThankYouPage";
import AdminPage from "./pages/AdminPage";
import DesignPreviewPage from "./pages/DesignPreviewPage";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/our-clients" element={<OurClientsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/admin/leads" element={<AdminPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/design-preview" element={<DesignPreviewPage />} />
          {/* Legacy redirects — drop /login, /signup, /dashboard, etc. */}
          <Route path="*" element={<LandingPage />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
